import { siteConfig } from "@acme/config";
import { useId } from "react";
import { getCtaConfig } from "~/lib/constants/navbar";
import * as m from "~/paraglide/messages.js";

/**
 * The close. The two offset squares behind the panel are drawn in CSS from
 * --shadow-square-l / --shadow-square-r rather than as elements, so they cost
 * nothing and cannot be read by a screen reader.
 */
export function ClosingPanel() {
  const titleId = useId();
  const cta = getCtaConfig();

  return (
    <section
      aria-labelledby={titleId}
      className="wrap start-conversation"
      id="contact"
    >
      <div className="closing-panel">
        <img
          alt=""
          className="closing-mark"
          height={52}
          loading="lazy"
          src="/images/icon.svg"
          width={52}
        />

        <h2 id={titleId}>
          {m.home_closing_title_1()} <br />
          {m.home_closing_title_2()}
        </h2>

        <p>
          {m.home_closing_lede_1()} <br />
          {m.home_closing_lede_2()}
        </p>

        <div className="closing-actions">
          <a
            className="button button-solid"
            href={cta.href}
            rel="noopener"
            target="_blank"
          >
            {m.home_closing_cta_call()} <span aria-hidden="true">↗</span>
          </a>
          <a
            className="button closing-email"
            href={`mailto:${siteConfig.contacts.mail}`}
          >
            {m.home_closing_cta_write()}
          </a>
        </div>

        <span className="closing-note">{m.home_closing_note()}</span>
      </div>
    </section>
  );
}
